
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.126","height":"18.126"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 1433"}},[_c('path',{attrs:{"data-name":"Tracé 6769","d":"M17.619 2.948l-6.115 6.114 6.117 6.115a1.727 1.727 0 11-2.442 2.442l-6.117-6.115-6.114 6.115a1.727 1.727 0 11-2.444-2.442l6.117-6.115L.504 2.948A1.728 1.728 0 012.948.504l6.115 6.117L15.177.504a1.727 1.727 0 112.442 2.442z","fill":"#044370"}})])])
          )
        }
      }
    